import { Modal } from "flowbite-react";
import FormRegisterIndicator from "../forms/FormRegisterIndicator";
import { registerIndicator } from "../../../../common/services/ambassador";

type Props = {
  open: boolean;
  onClosed: (success?: boolean) => void;
};

export default function ModalRegisterIndicator(props: Props) {
  const handleCloseModal = () => { props.onClosed && props.onClosed() }

  async function handleSubmit(dataToSave) {
    try {
      const result = await registerIndicator(dataToSave);

      const { ok } = result;

      if (!ok) {
        throw new Error('Erro ao tentar salvar o indicador, tente novamente');
      }
      props.onClosed(true);
    } catch (err) {
      console.error(err);
      props.onClosed(false);
    }
  }

  return (
    <Modal
      className="relative"
      show={props.open}
      onClose={() => handleCloseModal()}
    >
      <Modal.Header className="text-black"><h2 className="text-black">{'Novo Embaixador'}</h2></Modal.Header>
      <Modal.Body className="dark:text-black">
        <FormRegisterIndicator onSubmit={handleSubmit} />
      </Modal.Body>
    </Modal>
  );
}